import React from 'react';
import { components } from 'react-select';

const MapDealMultiselectCheckbox = (props) => {
    console.log('MultiselectCheckbox props:', props);
    return (
        <components.Option {...props}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <input
              type="checkbox"
              checked={props.isSelected}
              onChange={() => null} // Prevents the dropdown from closing when clicking on the checkbox
              style={{ margin: 0 }}
            />
            <label style={{ marginLeft: 8, marginBottom: 0 }}>
            {props.children}
            </label>
          </div>
        </components.Option>
      );
};

export default MapDealMultiselectCheckbox;
